import {SERVICE_ENDPOINT} from "../const";
import {gatewayInstance} from "../axiosInstance";


export const shipmentsByCustomer = async (customerId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stkShipmentTypeView/customershipment/${customerId}`,
        );

        return response.data.map((item) => ({
            key: item.id,
            text: item.text,
            value: item.id,
        }));
    } catch (e) {
        console.error("shipmentsByCustomer error:", e?.message || e);
    }
};

